export default "__VITE_ASSET__e40fa351__"